import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { generateSampleDetailsParams } from '@features/filter/static/filterUtil';
import SampleRequestCard from '@features/sampleDevelopment/components/SampleRequestCard';

import { handleFilterOfListPage } from '@store/actions/FilterAction';

const SampleVIewForOthers = () => {
	const dispatch = useDispatch();
	const { id } = useParams();
	const sampleData = useSelector((store) => store.filterResponseStore);
	const filterfields = useSelector((store) => store.filterFieldStore);
	const { ...paramsData } = generateSampleDetailsParams(filterfields);

	return (
		<SampleRequestCard
			fetchDevelopmentList={() =>
				dispatch(
					handleFilterOfListPage({ type: 'sampleDetailsAction', idUrl: `${id}` }, paramsData, false)
				)
			}
			sampleRequestId={id}
			sampleData={sampleData}
			cardType="SAMPLE_VIEW"
		/>
	);
};

export default SampleVIewForOthers;
